<template>
    <div 
        class="content-box" 
        @click.stop="cutEdit"
        >
        <!-- 分页 -->
        <div 
            v-if="question.questionsTypeId == 402 || question.questionsTypeId == 404" 
            class="box content"
        >
            <div class="box-f">
            <span
                class="outline-none"
                v-html="question.questionsName"
            ></span>
            <span style="display: inline-block;">{{ question.pageIndex + 1 }}/{{paper.pageCount}}</span>
            </div>
            <div class="box-icon" v-if="!isTestEdit && !istestPreview && question.pageIndex != 0">
                <el-tooltip content="拖动分页" placement="top" effect="light">
                    <i class="el-icon-rank handle"></i>
                </el-tooltip>
                <el-tooltip content="复制分页" placement="top" effect="light">
                    <i 
                        v-if="question.isedit"
                        class="el-icon-document-add" 
                        @click="copyQuestion(question)"
                    ></i>
                </el-tooltip>
                <el-tooltip content="复制分页" placement="top" effect="light">
                    <i v-if="question.isedit" class="el-icon-delete" @click="delQuestion(question.qid)"></i>
                </el-tooltip>
            </div>
        </div>

        <!-- 段落 -->
        <div 
            v-else-if="question.questionsTypeId == 401" class="box content" >
            <div class="box-f" @click="setActiveInput(question.qid)">
                <TitleEditor 
                    class="outline-none" 
                    :qid="question.qid" 
                    :class="question.qid"  
                    :value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
                    @childValueChange="val=>{question.questionsName = val }" 
                ></TitleEditor>
            </div>
            <div class="box-icon" v-if="!isTestEdit && !istestPreview">
                <el-tooltip content="拖动" placement="top" effect="light">
                    <i class="el-icon-rank handle"></i>
                </el-tooltip>
                <el-tooltip content="复制" placement="top" effect="light">
                    <i 
                        class="el-icon-document-add" 
                        @click="copyQuestion(question)"
                    ></i>
                </el-tooltip>
                <el-tooltip content="删除" placement="top" effect="light">
                    <i class="el-icon-delete" @click="delQuestion(question.qid)"></i>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
        name: 'QuestionOtherType',
        components: {
            TitleEditor
        },
        props: {
            paper: {
                type: Object,
                default: () => {}
            },
            // 单独的试题编辑（只能编辑当前试题 不能复制以及 移动）
            isTestEdit: {
                type: Boolean,
                default: false
            },
            question: {
                type: Object,
                default: () => {}
            },
            // 单独试题预览 不能对试题进行操作
            istestPreview: {
                type: Boolean,
                default: false
            },
            qindex: { type: Number, default: 0 },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            // 点击切换模态框形式
            cutEdit() {
                let state = this.question.isedit
                this.$emit("cutEdit");
                this.question.isedit = true
            },
            // 复制当前题目
            copyQuestion(){
                this.$emit("cutEdit");
                this.$emit('copyQuestion', this.question, this.qindex)
            },
            // 点击删除
            delQuestion() {
                this.$emit("delQuestion", this.question.qid, this.question.questionsTypeId);
            },
        }
    }
</script>
<style scoped lang="scss">
    
.content-box{
  background-color: rgb(255, 255, 255);
}
.content{
  padding: 0 10px;
}
.box {
  display: flex;
  justify-content: space-between;
}
.box-f{
  width: 80%;
font-size: 14px;
  display: flex;
}
.box-f span {
  padding-right: 15px;
}
.box-icon i {
//   padding-left: 20px;
    display: inline-block;
    margin-right: 20px;
    font-size: 18px;
    cursor: pointer;
}
</style>